import {Achievement} from './achievement';
import {Heroe} from '@/app/core/models/heroe/heroe';
import {SupportedLang} from '@/app/core/models/supportedLang';
import {RosterType} from '@/app/core/models/rosterType';

export interface Member {
	id: string;
	pseudo: string;
	lastname: string;
	firstname: string;
	nationality: string;
	age: number;
	dateOfBirth: string;
	role: MemberRole,
	isSubstitute: boolean;
	imageKey: string;
	twitterUsername: string;
	instagramUsername: string;
	tiktokUsername: string;
	youtubeUsername: string;
	twitchUsername: string;
	rosterType: RosterType;
	achievements: Achievement[];
	favoriteHeroes: Heroe[];
	translations: Record<SupportedLang, MemberTranslation>;
}

export enum MemberRole {
	DAMAGE = 'DAMAGE',
	TANK = 'TANK',
	SUPPORT = 'SUPPORT',
	DUELIST = 'DUELIST',
	STRATEGIST = 'STRATEGIST',
	VANGUARD = 'VANGUARD',
	PLAYER = 'PLAYER',
	COACH = 'COACH',
	TEAM_MANAGER = 'TEAM_MANAGER',
}

export interface MemberTiny {
	id: string;
	pseudo: string;
	role: MemberRole;
	imageKey: string;
	isSubstitute: boolean;
}

export interface MemberTranslation {
	description: string;
}
